import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import TaskJobDetails from './TaskJobDetails';
import authService from './api-authorization/AuthorizeService';

interface JobEnquiry {
    id: number;
    jobDetails: JobDetails;
    goAheadId: number;
    siteVisitId: number;
    cancelReasonId: number;
    cancelReasons: GenericList[];
    loading: boolean;
    errors: any;
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    siteAddress: string;
    lotNumber: string;
}

interface INameToValueMap {
    [key: string]: any;
}

interface GenericList {
    id: number;
    name: string;
}

export class TaskFollowUpJobEnquiryData extends React.Component<RouteComponentProps<{}>, JobEnquiry> {
    constructor(props: any) {
        super(props);
        this.state = { 
            id: 0,
            jobDetails: {
                jobId: 0,
                customer: "",
                customerContact: "",
                mobile: "",
                phone: "",
                siteAddress: "",
                lotNumber: ""
            },
            goAheadId: -1,
            siteVisitId: -1,
            cancelReasonId: -1,
            cancelReasons: [],
            loading: true,
            errors: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        this.setState({ id: Id });

        axios.get('api/User/CheckUserPermission?Permission=RunFollowUpJobEnquiryTask&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //get the list of cancel reasons for any existing jobs 
                axios.get('api/Job/GetCancelReasons?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ cancelReasons: res.data })

                    //assign task to current user
                    var taskdetails = {
                        Id: Id,
                        SubId: user.sub
                    };
                    axios.post('api/Tasks/AssignTask', taskdetails, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                    .then(res => {
                        //this needs to just happen in the background
                    });

                    axios.get('api/Tasks/GetTaskFollowUpJobEnquiryDetails?Id=' + Id, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                    .then(res => {
                        this.setState({ id: Id, jobDetails: res.data, loading: false });
                    })
                    .catch(error => {
                        toast.error(error.message);
                    });
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    validate = () => {
        let formIsValid = true;
        let errors: any = {};

        if (this.state.goAheadId < 1) {
            formIsValid = false;
            errors["goAheadId"] = "Is the job going ahead is required";
        } else if (this.state.goAheadId == 1 && this.state.siteVisitId < 1) {
            formIsValid = false;
            errors["siteVisitId"] = "Plans or Site Visit is required";
        } else if (this.state.goAheadId == 3 && this.state.cancelReasonId < 1) {
            formIsValid = false;
            errors["cancelReasonId"] = "Cancel Reason is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    contactSubmit = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.submit();
        } else {
            //alert("Form has errors.")
        }

    }

    submit = () => {
        this.save();
    }

    async save() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var details = {
            taskId: this.state.id,
            jobId: this.state.jobDetails.jobId,
            goAheadId: this.state.goAheadId,
            siteVisitId: this.state.siteVisitId,
            cancelReasonId: this.state.cancelReasonId,
            subId: user.sub
        };

        axios.post('api/Tasks/SaveFollowUpJobEnquiry', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Task Saved");
            this.props.history.push("/tasks")
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Follow Up Job Enquiry</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var jobDetails = this.state.jobDetails;
        var phone = jobDetails.mobile != "" && jobDetails.phone != "" ? jobDetails.mobile + " or " + jobDetails.phone : jobDetails.mobile != "" ? jobDetails.mobile : jobDetails.phone;
        let cancelReasonOptions = this.state.cancelReasons;
        let taskJobDetails = <TaskJobDetails jobDetails={jobDetails} />

        return (
            <form name="jobDetails" onSubmit={this.contactSubmit}>
                <div>
                    <span>Please call {jobDetails.customerContact} from {jobDetails.customer} on {phone} to see if the below job is going ahead:</span>
                    {taskJobDetails}
                    <div>
                        <label className="input-group" htmlFor="goAheadId">
                            <span className="label">Is the job going ahead?</span>
                            <select className="select" id="goAheadId" name="goAheadId" value={this.state.goAheadId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                <option value="1">Yes - Going Ahead</option>
                                <option value="2">Pending</option>
                                <option value="3">No - Cancel Job</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["goAheadId"]}</span>
                    </div>
                    <br></br>
                    <div className={this.state.goAheadId == 1 ? "" : "hidden"}>
                        <span>Can you please send through the plans so we can quote the job or does it require a site visit from us?</span>
                        <label className="input-group" htmlFor="siteVisitId">
                            <span className="label">Plans or Site Visit?</span>
                            <select className="select" id="siteVisitId" name="siteVisitId" value={this.state.siteVisitId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                <option value="1">Will Send Plans</option>
                                <option value="2">Plans Sent</option>
                                <option value="3">Needs Site Visit</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["siteVisitId"]}</span>
                    </div>
                    <div className={this.state.goAheadId == 3 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="cancelReasonId">
                            <span className="label">Cancel Reason</span>
                            <select className="select" id="cancelReasonId" name="cancelReasonId" value={this.state.cancelReasonId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                {cancelReasonOptions.map(reason =>
                                    <option key={reason.id} value={reason.id}>{reason.name}</option>
                                )};
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["cancelReasonId"]}</span>
                    </div>
                    <div className="row">
                        <button className="defaultbutton-prev" type="submit">Save</button>
                    </div>
                </div>
            </form>
        );
    }
}
